var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResultsIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 67,
    viewBox: "0 0 77 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_824_34792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2939 0C34.2408 6.14435e-05 35.1068 0.534924 35.5303 1.38184L38.5889 7.5H57.8496C59.2878 7.5002 60.429 8.71079 60.3447 10.1465L59.9199 17.3643C59.8507 16.0557 58.7676 15.0002 57.4248 15H31.9141L28.8555 8.88184C28.432 8.03492 27.566 7.50006 26.6191 7.5H10.3076L10.0049 2.65625C9.91493 1.217 11.0579 0 12.5 0H33.2939Z",
    fill: "#2242A7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6611 31.8008C48.5693 25.994 58.0661 26.0763 63.873 31.9844C69.1321 37.335 69.5602 45.6279 65.2061 51.459C65.2503 51.4976 65.295 51.5365 65.3369 51.5791L75.8525 62.2773C76.7457 63.1863 76.7331 64.6477 75.8242 65.541C74.9153 66.4344 73.4539 66.4216 72.5605 65.5127L62.0459 54.8145C62.004 54.7718 61.9657 54.7266 61.9277 54.6816C56.0223 58.9352 47.7369 58.3646 42.4775 53.0137C36.6705 47.1055 36.753 37.6078 42.6611 31.8008ZM60.582 35.2197C56.5618 31.1295 49.9868 31.0726 45.8965 35.0928C41.8062 39.1131 41.7492 45.688 45.7695 49.7783C49.7898 53.8685 56.3648 53.9255 60.4551 49.9053C64.5453 45.8851 64.602 39.31 60.582 35.2197Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8223 7.50586C27.699 7.56786 28.4849 8.08793 28.8818 8.88184L31.9404 15H57.4512C58.8893 15.0002 60.0306 16.2108 59.9463 17.6465L59.29 28.793C57.8719 28.161 56.3381 27.741 54.7285 27.5771L55.1973 19.625H29.082L25.332 12.125H8.11328L10.0352 42.875H38.1963C38.236 44.4934 38.5326 46.0479 39.0459 47.5H8.03906L7.79395 47.4883C6.66658 47.3784 5.75117 46.5178 5.57129 45.3994L5.54395 45.1562L3.35645 10.1562C3.27211 8.80693 4.27145 7.65257 5.58496 7.51367L5.85156 7.5H26.6455L26.8223 7.50586Z",
    fill: "#2D5EFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_824_34792",
    x: 0,
    y: 0,
    width: 70.3477,
    height: 37.3643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_824_34792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_824_34792",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResultsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-results-icon.9330effa926b8dbee4e05579e06c7cf4.svg";